<template>
    <div style="height: 100%; display: flex; align-items: center">
        <transition name="fade">
            <lottie-animation
                v-if="type == 'list'"
                style="height: 10rem"
                path="lottie/dots.json"
            />
            <div class="chat-loader" v-if="type == 'chat'">
                <div class="dot"></div>
                <div class="dot second"></div>
                <div class="dot third"></div>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    name: 'ListLoading',
    props: {
        type: {
            type: String,
            default: () => {
                return 'list'
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.chat-loader {
    padding: 0;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    justify-items: center;
    align-items: center;
}
.dot {
    margin: 0.2rem;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 100%;
    background: rgb(255, 255, 255) !important;
    animation: dots 1.3s infinite;
}
.second {
    animation-delay: 0.15s;
}
.third {
    animation-delay: 0.3s;
}
@keyframes dots {
    20% {
        transform: translateY(-5px);
    }
    40% {
    }
    80% {
        transform: translateY(0px);
    }
}
</style>
